$ = jQuery;

$( document ).ready( function( $ ) {
	"use strict";
	$( '.hamburger' ).click( function() {
		let $this = $( this );
		$( this ).toggleClass( 'is-active' );
		$( 'body' ).toggleClass( 'no-scroll' );
	} );

	$( window ).scroll( function() {
		if ( $( window ).scrollTop() > 100 ) {
			$( '#masthead' ).addClass( 'scroller' );
		} else {
			$( '#masthead' ).removeClass( 'scroller' );
		}
	} );

	$( '.testimonials-slider' ).slick( {
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
		centerMode: true,
		centerPadding: '60px',
		variableWidth: true,
		autoplay: true,
		autoplaySpeed: 2500,
	} );

	$( '.why-us-content:not(.active)' ).hide();

	$( ".why-us-title .h5" ).click( function() {
		let tabTarget = $( this ).data( 'target' );

		$( ".why-us-title .h5.active" ).removeClass( 'active' );
		$( this ).toggleClass( 'active' );
		$( '.why-us-content ' ).hide();
		$( '.why-us-content-' + tabTarget ).fadeIn();
	} );

	$( '#primary-menu > .menu-item-has-children' ).click( function( e ) {

		if ( $( e.target ).parent().hasClass( 'nav-menu' ) ) {
			$( this ).toggleClass( 'open' );

			if ( $( this ).hasClass( 'open' ) ) {
				$( this ).find( '> ul' ).slideDown();
			} else {
				$( this ).find( '> ul' ).slideUp();
			}
		}
	} );

	$( '.sub-menu > .menu-item-has-children' ).click( function(e) {
		if ( $( e.target ).parent().hasClass( 'sub-menu' ) ) {
			$( this ).toggleClass( 'open' );

			if ( $( this ).hasClass( 'open' ) ) {
				$( this ).find( '> ul' ).slideDown();
			} else {
				$( this ).find( '> ul' ).slideUp();
			}
		}
	} );

	// testimonials acordion

    $('.site-content .accordion-title').click(function (){
        $(this).toggleClass('active');
        if($(this).hasClass('active')){
            $(this).next().addClass('open');
        }else{
            $(this).next().removeClass('open');
        }
    });

    //FAQ

	$( '.faq-title' ).click( function() {
		$( this ).toggleClass( 'open' );
		$( this ).parent().toggleClass( 'open' );
		if ( $( this ).hasClass( 'open' ) ) {
			$( this ).next().slideDown();
		} else {
			$( this ).next().slideUp();
		}
	} );

	$(".datechk").datepicker();

	/**
	* Nice select
	*/
	$('select').niceSelect();

  $('form').find("input[name=origin]").each(function(ev){
  if(!$(this).val()) {
     $(this).attr("placeholder", "Origin Zip Code");
  }
  });
  $('form').find("input[name=destination]").each(function(ev){
      if(!$(this).val()) {
	     $(this).attr("placeholder", "Destination Zip Code");
	  }
  });
} );

var phone_input = document.getElementById('phone-number');

function validDigits(n){
  return n.replace(/[^0-9]+/g, '');
}

phone_input.addEventListener('keyup', function(){
  var field = phone_input.value;
  phone_input.value = validDigits(field);
});
